import { getApiUrl } from '../utils/apiUrl';

const API_URL = getApiUrl();

const buildHeaders = (token) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`,
});

const handleResponse = async (response, errorMessage) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || errorMessage);
  }
  return response.json();
};

export const fetchDailySales = async (token, days = 30) => {
  const response = await fetch(`${API_URL}/statistics/daily-sales?days=${days}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente salgsdata.');
};

export const recalculateDailySales = async (token, days = 90) => {
  const response = await fetch(`${API_URL}/statistics/daily-sales/recalculate`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify({ days }),
  });
  return handleResponse(response, 'Kunne ikke beregne salgsdata på nytt.');
};

export const fetchSellers = async (token) => {
  const response = await fetch(`${API_URL}/statistics/daily-sales/sellers`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente selgere.');
};

export const fetchSellerSales = async (token) => {
  const response = await fetch(`${API_URL}/statistics/daily-sales/seller-sales`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente selgersalg.');
};
